import { ApiFunc, getInstance } from '@src/helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const workPlanCreate: ApiFunc<`${typeof API.WORK_PLAN}`, 'post'> = data => instance.post(API.WORK_PLAN, data)

export const workPlanDelete: ApiFunc<`${typeof API.WORK_PLAN}{id}`, 'delete'> = data =>
  instance.delete(`${API.WORK_PLAN}${'id' in data ? data.id : data.name}`)

export const workPlanAssignedAll: ApiFunc<`${typeof API.WORK_PLAN_ASSIGNED_ALL}`, 'get'> = data =>
  instance.get(API.WORK_PLAN_ASSIGNED_ALL, { params: data })

export const workPlanCreatedAll: ApiFunc<`${typeof API.WORK_PLAN_CREATED_ALL}`, 'get'> = data =>
  instance.get(API.WORK_PLAN_CREATED_ALL, { params: data })

export const workPlanUpdate: ApiFunc<`${typeof API.WORK_PLAN_UPDATE}`, 'post'> = data =>
  instance.post(API.WORK_PLAN_UPDATE, data)

export const workPlanUpdateStatus: ApiFunc<`${typeof API.WORK_PLAN_UPDATE_STATUS}`, 'post'> = data =>
  instance.post(API.WORK_PLAN_UPDATE_STATUS, data)

export const workPlanStaffList: ApiFunc<`${typeof API.WORK_PLAN_STAFF_LIST}`, 'get'> = data =>
  instance.get(API.WORK_PLAN_STAFF_LIST, { params: data })
